module.exports = __webpack_public_path__ + "static/media/home-page-search.df65d706.png";